var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlur14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 778,
    height: 778,
    viewBox: "0 0 778 778",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    filter: "url(#filter0_f_66_11280)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 389,
    r: 239,
    fill: "#D345F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_66_11280",
    x: 0,
    y: 0,
    width: 778,
    height: 778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_66_11280"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur14);
export default __webpack_public_path__ + "static/media/blur-14.f24400e444ed76bb2ebd3cc3f516c6ba.svg";
export { ForwardRef as ReactComponent };